
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
import common_helper from '../../../common_helper'
Vue.component("downloadExcel", JsonExcel);
import moment from 'moment';
export default {
	name: 'FalseblockedRackstock',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
	},

	data: function () {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			isLoading: false,
			resultCount: '',
			userid: '',
			clientsearch: '',
			listClientData: [],
			listWarehouseData: [],
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			stockTypeArr: ['Accept', 'Reject'],
			stocktype: '',
			limitExeed: '',
			download: true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: '',
			listBlockedData: [],
			warehousesearch: '',
			show: false,
			orderstatuslist: ['Resolved', 'NotResolved'],
			searchstatus: '',
			stockTypeErr: '',
			dataFilter: {},
			productid: '',
			rackid: '',
			//	selectedList: [],
		}
	},
	//uniwareFailedInvoiceList
	created: function () { },
	// when a page loads,mounted() will be call
	filters: {
		moment: function (dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;

		this.pageno = 0;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.reportname = this.$t('editedjson.FalseBlockedRackReport'),
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				//this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.clientsearch = this.clientid;
				// this.getWarehouseList();

				this.showSelectWarehouse = true;
				break;
			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();



				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getFalseBloackeddata(3)
			}
		},


		////////
		// async getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});
		// 		let result = await common_helper.getRestApiResponse('POST', 'getClientAssociatedWarehouseList', this.input, this.$alertify)
		// 		if (result && !result.errorDATA) {
		// 			this.listWarehouseData = result.data.data;
		// 		}
		// 	}
		// },

		// async getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		this.input = ({
		// 			'warehouseid': this.warehouseid,
		// 		});

		// 		let result = await common_helper.getRestApiResponse('POST', 'getWarehouseAssociatedClientList', this.input, this.$alertify)
		// 		if (result && !result.errorDATA) {
		// 			this.listClientData = result.data.data;
		// 		}
		// 	}
		// },

		// clientSelected(type) {
		// 	this.warehousesearch = '';
		// 	if (type == 'list') {
		// 		this.clientid = this.clientsearch;
		// 		if (this.clientid) {
		// 			if (!this.warehouseid) {
		// 				this.getWarehouseList();
		// 			}
		// 		}
		// 	} else {
		// 		this.clientid = this.client;
		// 		this.getWarehouseList();
		// 	}
		// },

		// warehouseSelected(type) {
		// 	if (type == 'list') {
		// 		this.warehouseid = this.warehousesearch;
		// 		if (this.warehouseid) {
		// 			if (!this.clientid) {
		// 				this.getClientList();

		// 			}
		// 		} else {
		// 			this.warehouseid = this.warehouse;
		// 		}
		// 	}
		// },


		// This function for get box list
		async getFalseBloackeddata(csvCheck = 0) {
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;

			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedWarehouse") == 'undefined' || this.stocktype == '') {
				if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
					this.$alertify.error(this.$t('common.clientError'))
					return false;
				}

				else if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				}
				else
					this.stockTypeErr = this.$t('common.stockTypeRequired');
				this.pageno = this.pageCount = 0;
				this.listBlockedData = [];
				return false;
			}



			this.input = ({
				'clientid': localStorage.getItem("selectedClient"),
				'warehouseid': localStorage.getItem("selectedWarehouse"),
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'stocktype': this.stocktype,
				'csvData': csvCheck,
				'productid': this.productid,
				'rackid': this.rackid,
			});
			this.dataFilter = {}
			let str = '', value = '', dataFilter2 = {};
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter = str.concat(value);
					dataFilter2[k] = v;
				}
			})

			if (localStorage.getItem("selectedClient") && localStorage.getItem("selectedWarehouse")) {
				this.isLoading = true;
				let result = await common_helper.getRestApiResponse('POST', 'falseBlockedStockList', this.input, this.$alertify)
				if (result && !result.errorDATA) {
					console.log(result, "result");
					if (csvCheck == 1 || csvCheck == 3) {
						if (result.data.data[0].count < 10000) {

							this.show = true;
							this.download = false;
							this.listAuditDatacsv = [];
							if (csvCheck == 1) {
								this.csvFields = {
									'rackid': this.$t('warehouseRacks.rackId'),
									'racktype': this.$t('common.rackType'),
									'productid': this.$t('stockTransfer.productID'),
									'mrp': this.$t('printProductDetails.mrp'),
									'totalqty': this.$t('srReport.totalQtyOnRack'),
									'whcurrentstock': this.$t('daywiseatpstock.currentstock'),
									'allocatedstock': this.$t('editedjson.allocatedStock'),
									'totalblockedstock': this.$t('editedjson.totalBlockedqty'),
								};
								let dateFilter = [''];
								let skipFilter = ['count', 'id']
								this.listBlockedDatacsv = [];
								this.listBlockedDatacsv = result.data.data;

								csvHelper.data.jsonToCSV(this.$t('editedjson.FalseBlockedRackReport'), this.listBlockedDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter2);
							} else {
								this.csvFieldsForXls =[];
								this.csvFieldsForXls[this.$t('warehouseRacks.rackId')] = 'rackid';
								this.csvFieldsForXls[this.$t('common.rackType')] = 'racktype';
								this.csvFieldsForXls[this.$t('stockTransfer.productID')] = 'productid';
								this.csvFieldsForXls[this.$t('printProductDetails.mrp')] = 'mrp';
								this.csvFieldsForXls[this.$t('srReport.totalQtyOnRack')] = 'totalqty';
								this.csvFieldsForXls[this.$t('daywiseatpstock.currentstock')] = 'whcurrentstock';
								this.csvFieldsForXls[this.$t('editedjson.allocatedStock')] = 'allocatedstock';
								this.csvFieldsForXls[this.$t('editedjson.totalBlockedqty')] = 'totalblockedstock';

								this.listReportDataforxls = result.data.data;

							}
							this.isLoading = false;
						} else {
							this.isLoading = false;
							this.$alertify.success(this.$t('common.reportSizeError'));
						}
					} else {
						if (result.data.data.length > 0) {
							this.listBlockedData = result.data.data;
							this.resultCount = result.data.data[0].count;
							this.totalRows = Number(result.data.data[0].count);
							this.setPageCounts(result.data.data[0].count);
						} else {
							this.$alertify.error(this.$t('srReport.dataNotFound'))
							this.resetFormData()
						}
						this.isLoading = false;

					}
				}
			} else {
				this.listBlockedData = [];
				this.resultCount = 0;
				this.setPageCounts(0);

				if (!localStorage.getItem("selectedClient")) {
					this.ClientErr = this.$t('srReport.clientError');
				}
				if (!localStorage.getItem("selectedWarehouse")) {
					this.ClientErr = this.$t('common.warehouseError');
				}
			}
		},


		onPageChange(page) {
			this.currentPage = page;
			this.getFalseBloackeddata(2)
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalPage = 0;
			}
		},

		resetFormData() {
			this.productid = '';
			this.rackid = '';
			this.totalRows = 0;
			this.clientsearch = '';
			this.warehousesearch = '';
			this.totalPage = 0;
			this.listBlockedData = [];
			this.stockTypeErr = "";
			this.resultCount = 0;
			this.ClientErr = "";
			this.WarehouseErr = "";
			this.stocktype = "";
			if (this.user_type == 'warehouse_user') {
				this.clientid = '';
			} else if (this.user_type == 'client_user') {
				this.warehouseid = '';
			} else {
				this.clientid = '';
				this.warehouse = '';
				this.warehouseid = '';
			}
		},

	}
}


// WEBPACK FOOTER //
// ./src/views/components/falseblockedrackstock/falseblockedrackstock.component.js